import { useBottomSheet } from '../../../state-management/contexts/BottomSheetContext'
import { RestrictedAccessInfoBottomSheet } from './RestrictedAccessInfoBottomSheet'
import { GoToPortfolioButton } from './GoToPortfolioButton'
import { useNewEliteLandingAnalyticsScreen } from '../analytics/NewEliteLandingAnalyticsContext'
import {
  NewEliteLandingBottomSheetName,
  NewEliteLandingEventId,
  trackNewEliteUserClicked
} from '../analytics/newEliteLandingAnalytics'

import { useEliteBuyCtaExtras } from '../../../components/elite/EliteBuyCtaExtrasContext'
export default function RestrictedAccessBanner() {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()
  const analyticsScreen = useNewEliteLandingAnalyticsScreen()
  const eliteBuyCtaExtras = useEliteBuyCtaExtras()

  const handleRestrictedAccessInfoClick = () => {
    trackNewEliteUserClicked(analyticsScreen, NewEliteLandingEventId.RestrictedAccessInfoOpen, {
      ...eliteBuyCtaExtras,
      bottomSheetName: NewEliteLandingBottomSheetName.RestrictedAccessInfo
    })
    openBottomSheet(<RestrictedAccessInfoBottomSheet onDismiss={closeBottomSheet} />)
  }

  return (
    <div className='flex flex-col items-center px-5'>
      <GoToPortfolioButton eventId={NewEliteLandingEventId.GoToPortfolioLocked} />
      <div className='flex flex-col items-center gap-4 mb-6'>
        <div className='relative'>
          <img src='/images/new-elite/powerup-logo.svg' alt='powerup-logo' className='h-16 w-16 rounded-2xl' />
          <img
            src='/images/new-elite/exclamation.svg'
            alt=''
            className='absolute -right-2 -top-2 h-5 w-5'
          />
        </div>
        <div className='max-w-[280px] text-center text-lg font-medium leading-[1.4] text-[#65321D]'>
          Your access to PowerUp <br />app is now restricted
        </div>
      </div>
      <div className='flex flex-col items-center gap-3'>
        <div className='max-w-[300px] text-center text-sm font-normal leading-[1.4] text-[#65321D]'>
          Renew Elite membership to get uninterrupted access to all insights and app features.
        </div>
        <div
          className='cursor-pointer text-center text-sm text-[rgba(101,50,29,0.60)] underline'
          onClick={handleRestrictedAccessInfoClick}
        >
          Why is my access restricted?
        </div>
      </div>
    </div>
  )
}
